import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import { isMobileMode } from '@app/utils/utils';

import './Button.scss';

const Button = React.forwardRef(
  ({ children, className, onClick, isMobileView, locKey, hidden = false, disabled = false, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      disabled={disabled}
      tabIndex={disabled || hidden ? -1 : 0}
      className={classnames('qau-button', className, { hidden, disabled, mobile: isMobileView })}
      data-ln-id={locKey || undefined}
      {...props}
    >
      {locKey ? <LocalizedText id={locKey} tagName={null} /> : children}
    </button>
  ),
);

const mapStateToProps = ({ matrix: { ctx } }) => ({ isMobileView: isMobileMode(ctx) });

Button.propTypes = {
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  locKey: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  isMobileView: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, {}, null, { forwardRef: true })(Button);
